import { Identifiable } from '@mews/std';
import {
    AddCustomerIdentityDocumentParameters,
    DeleteCustomerIdentityDocumentParameters,
    UpdateCustomerIdentityDocumentParameters,
} from '@mews-commander/data-access';
import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { createFetchAction } from '@mews-commander/utils';
import {
    getIdentityDocument,
    IDENTITY_DOCUMENT_ADD,
    IDENTITY_DOCUMENT_DELETE,
    IDENTITY_DOCUMENT_UPDATE,
} from '../ducks/identityDocuments';

export interface AddDocumentProps extends Omit<AddCustomerIdentityDocumentParameters, 'customerId'> {
    ownerId: string;
}

export interface UpdateDocumentProps
    extends Identifiable,
        Omit<UpdateCustomerIdentityDocumentParameters, 'customerId' | 'identityDocumentId'> {
    ownerId: string;
}

interface DeleteDocumentProps extends Identifiable, DeleteCustomerIdentityDocumentParameters {
    ownerId: string;
}

export const addDocument =
    ({ ownerId, ...other }: AddDocumentProps): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.customers.addIdentityDocument({ customerId: ownerId, ...other }).then((doc) => ({
            ownerId,
            ...doc,
        }));
        return dispatch(createFetchAction(IDENTITY_DOCUMENT_ADD, promise));
    };

export const updateDocument =
    ({ ownerId, id, ...other }: UpdateDocumentProps): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.customers
            .updateIdentityDocument({ customerId: ownerId, identityDocumentId: id, ...other })
            .then((doc) => ({
                ownerId,
                ...doc,
            }));
        return dispatch(createFetchAction(IDENTITY_DOCUMENT_UPDATE, promise));
    };

export const deleteDocument =
    ({ id, ownerId }: DeleteDocumentProps): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const doc = getIdentityDocument(getState(), { id });
        const promise = repositories.customers
            .deleteIdentityDocument({ identityDocumentId: id, customerId: ownerId })
            .then(() => doc);

        return dispatch(createFetchAction(IDENTITY_DOCUMENT_DELETE, promise));
    };
